import { ReactElement } from 'react';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';

import ProtectedRoute from 'components/ProtectedRoute';
import AuthorDashboard from 'pages/a/Dashboard';
import AuthorInbox from 'pages/a/Inbox';
import Article from 'pages/Article';
import Enter from 'pages/Enter';
import Home from 'pages/Home';
import PreEnter from 'pages/PreEnter';
import { store } from 'store/store';

function App(): ReactElement<HTMLElement> {
  return (
    <Provider store={store}>
      <Switch>
        <Route path="/" component={Home} exact />
        <Route path="/articles" component={Article} exact />
        <Route path="/enter" component={Enter} exact />
        <Route path="/pre-enter" component={PreEnter} exact />
        <ProtectedRoute path="/a/dashboard" component={AuthorDashboard} exact />
        <ProtectedRoute path="/a/inbox" component={AuthorInbox} exact />
      </Switch>
    </Provider>
  );
}

export default App;
